import {
  Container,
  Header,
  FormField,
  SpaceBetween,
  Box,
  RadioGroup,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { BankAccountsUpdateRequest } from "../../../features/api-interfaces";
import {
  CODE_MASTER,
  getDivisionLabel,
  COMMON_LABELS,
} from "../../default-constants";
import InfoField from "../../UI/InfoField";
import { LABELS } from "../constants";

interface IPaymentCycle {
  paymentCycleCode?: string;
  isUpdate?: boolean;
  editingRequest?: BankAccountsUpdateRequest;
  setEditingRequest?: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
}

/**
 * 入金口座情報照会・更新 支払サイクル
 */
export const PaymentCycle = (props: IPaymentCycle) => {
  const {
    paymentCycleCode,
    isUpdate = false,
    editingRequest,
    setEditingRequest,
  } = props;
  const paymentCycleCodes = CODE_MASTER["PAYMENT_CYCLE_CODE"];
  const displayPaymentCycleCode = getDivisionLabel(
    paymentCycleCodes,
    String(paymentCycleCode ?? "")
  );

  /**
   * 支払サイクルの入力ハンドラ.
   * @param {string} inputValue 入力値
   */
  const paymentCycleOnChange = (inputValue: string) => {
    if (editingRequest && setEditingRequest) {
      setEditingRequest({
        ...editingRequest,
        paymentCycleCode: inputValue,
      });
    }
  };

  return (
    <Container header={<Header variant={"h2"}>{LABELS.PAYMENT_CYCLE}</Header>}>
      <>
        {isUpdate ? (
          <FormField
            label={
              <SpaceBetween direction={"horizontal"} size={"xs"}>
                <Box variant={"strong"}>{LABELS.PAYMENT_CYCLE}</Box>
                <Box variant={"small"} color={"text-status-error"}>
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
            <RadioGroup
              items={paymentCycleCodes}
              onChange={({ detail: { value } }) => paymentCycleOnChange(value)}
              value={editingRequest?.paymentCycleCode ?? ""}
            />
          </FormField>
        ) : (
          <SpaceBetween direction={"horizontal"} size={"xxl"}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.PAYMENT_CYCLE]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxxs"}
              tag={"p"}
              values={[displayPaymentCycleCode]}
            />
          </SpaceBetween>
        )}
      </>
    </Container>
  );
};
